import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetRsvpQuestionsAction implements Action {
  public static readonly type = 'GetRsvpQuestionsAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetRsvpQuestionsAction.type;
}
